export default __webpack_public_path__ + "static/media/close.fd136d2a.svg";